import { render, staticRenderFns } from "./amazonOrder.vue?vue&type=template&id=7ea972ea&scoped=true"
import script from "./amazonOrder.vue?vue&type=script&lang=js"
export * from "./amazonOrder.vue?vue&type=script&lang=js"
import style0 from "./amazonOrder.vue?vue&type=style&index=0&id=7ea972ea&prod&scoped=true&lang=less"
import style1 from "./amazonOrder.vue?vue&type=style&index=1&id=7ea972ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea972ea",
  null
  
)

export default component.exports